import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { QuestionDefinitionModel } from 'src/app/shared/models/form/question-definition-model';
import { AttributeDefinitionCondition } from 'src/app/shared/models/attributes/attributeDefinitionCondition';

export class ConditionDefinitionModel {
  public id: string;
  public title: string;
  public conditionValues: ConditionValueModel[];

  public static parse(
    question: QuestionDefinitionModel,
    condition?: AttributeDefinitionCondition
  ): ConditionDefinitionModel {
    if (!question) return null;
    let conditionModel = new ConditionDefinitionModel();
    conditionModel.id = question.attributeDefinition.id;
    conditionModel.title = question.attributeDefinition.name;
    conditionModel.conditionValues = question.attributeDefinition.valueList.map((value) =>
      ConditionValueModel.parse(value, condition)
    );

    return conditionModel;
  }
}
export class ConditionValueModel {
  public id: string;
  public title: string;
  public selected: boolean;

  public static parse(
    valueListItem: AttributeDefinitionValueListItem,
    condition: AttributeDefinitionCondition
  ): ConditionValueModel {
    if (!valueListItem) return null;
    let conditionValue = new ConditionValueModel();
    conditionValue.id = valueListItem.id;
    conditionValue.title = valueListItem.itemValue;
    conditionValue.selected = condition
      ? condition.conditionValues.findIndex((x) => x == valueListItem.id) > -1
      : false;
    return conditionValue;
  }
}
